import { gql } from "@apollo/client"

export const TRAINING_COURSE_AUTO_ASSIGNMENT_FIELDS = gql`
  fragment TrainingCourseAutoAssignmentFragment on TrainingCourseAutoAssignment {
    reassignPeriodically
    reassignValue
    reassignUnit
    locations {
      id
      name
    }
    groups {
      id
      name
    }
    roles {
      id
      name
      friendlyName
    }
  }
`
